export default "__VITE_ASSET__IHCVFcza__"